import { MessageSquare, FileText, Globe } from "lucide-react";

const steps = [
  {
    number: "01",
    title: "Chat with us",
    subtitle: "Simple Onboarding",
    icon: MessageSquare,
    description:
      "Answer a few simple questions about your business, services, and coverage area. No forms to fill out.",
  },
  {
    number: "02",
    title: "Review Draft",
    subtitle: "Instant Preview",
    icon: FileText,
    description:
      "Our AI builds a professional site instantly. Review the copy and layout, and request changes just by asking.",
  },
  {
    number: "03",
    title: "Go Live",
    subtitle: "Publish & Grow",
    icon: Globe,
    description:
      "Connect your domain and go live. We handle the hosting, security, and SEO so you can focus on getting more work.",
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-32 relative">
      <div className="mx-auto max-w-6xl px-6">
        
        {/* Section Header */}
        <div className="mb-24 grid md:grid-cols-2 gap-12 items-end">
          <div>
            <div className="text-sm font-medium uppercase tracking-wider text-muted-foreground mb-4">
              Our Process
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-primary leading-tight">
              From chat to <br/>
              <span className="italic text-muted-foreground">live site in minutes.</span>
            </h2>
          </div>
          <p className="text-lg text-muted-foreground md:max-w-md leading-relaxed">
            Forget expensive agencies or complicated DIY builders. Just tell us what you do.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-8 border-t border-primary/10 pt-12">
          {steps.map((step) => (
            <div key={step.number} className="group relative flex flex-col justify-between h-full p-6 -mx-6 rounded-2xl hover:bg-secondary/30 transition-colors duration-500">
              <div>
                <div className="flex justify-between items-start mb-8">
                  <div className="size-12 rounded-full bg-secondary flex items-center justify-center text-primary group-hover:scale-110 transition-transform duration-500">
                    <step.icon className="size-6" />
                  </div>
                  <span className="font-display text-4xl font-medium text-primary/10 group-hover:text-primary/20 transition-colors duration-500">
                    {step.number}
                  </span>
                </div>
                
                <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-accent">
                  {step.subtitle}
                </div>
                <h3 className="font-display text-2xl font-medium mb-4 text-primary">
                  {step.title}
                </h3>
                
                <p className="text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}



